import { render, staticRenderFns } from "./TabPaneRcaFinal.vue?vue&type=template&id=2de79971&scoped=true"
import script from "./TabPaneRcaFinal.vue?vue&type=script&lang=js"
export * from "./TabPaneRcaFinal.vue?vue&type=script&lang=js"
import style0 from "./TabPaneRcaFinal.vue?vue&type=style&index=0&id=2de79971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de79971",
  null
  
)

export default component.exports